import React from 'react';
import T from 'prop-types';
import { Input, Form } from 'antd';
import capitalize from 'lodash.capitalize';

import { MODAL_RESEND_EMAIL_CONFIRMATION } from '../../../../constants/app';

import ErrorAlert from '../../../errorAlert';
import Modal from '../../../modal';
import FormItem from '../../../formItem';

import * as validators from '../../../../constants/validators';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};

const ResendEmailConfirmationModal = ({ error, errorMessage, isLoading, reset, resendEmailConfirmation }) => {
  const handleOnFinish = ({ email }) => {
    resendEmailConfirmation(email);
  };

  return (
    <Modal
      name={MODAL_RESEND_EMAIL_CONFIRMATION}
      okButtonProps={{ htmlType: 'submit', form: MODAL_RESEND_EMAIL_CONFIRMATION, loading: isLoading }}
      okText="Submit"
      onCancel={reset}
      title="Resend Confirmation Email"
    >
      <ErrorAlert message={capitalize(errorMessage)} visible={error} />
      <Form name={MODAL_RESEND_EMAIL_CONFIRMATION} onFinish={handleOnFinish} {...formItemLayout}>
        <FormItem label="E-mail" name="email" {...validators.email}>
          <Input />
        </FormItem>
      </Form>
    </Modal>
  );
};

ResendEmailConfirmationModal.propTypes = {
  resendEmailConfirmation: T.func.isRequired,
  reset: T.func.isRequired,

  error: T.bool.isRequired,
  errorMessage: T.string.isRequired,
  isLoading: T.bool.isRequired,
};

export default ResendEmailConfirmationModal;
